export type PaymentIntegrationProvider = 'ziina';

export type PaymentIntegrationAccountType = 'personal' | 'business';

export type PaymentIntegrationAccountStatus =
  | 'onboarding'
  | 'active'
  | 'locked'
  | 'deleted'
  | 'restrictedTransfer';

export interface VenuePaymentIntegrationStatus {
  provider: PaymentIntegrationProvider;
  name: string;
  description: string;
  isConnected: boolean;
  enabled: boolean;
  accountId: string | null;
  accountType: PaymentIntegrationAccountType | null;
  accountStatus: PaymentIntegrationAccountStatus | null;
  displayName: string | null;
  ziiname: string | null;
  profilePictureUrl: string | null;
  scopes: string[];
  lastConnectedAt: string | null;
  lastError: string | null;
  webhookRegisteredAt: string | null;
}

export const PAYMENT_INTEGRATION_PROVIDERS: Array<{
  id: PaymentIntegrationProvider;
  name: string;
  description: string;
}> = [
  {
    id: 'ziina',
    name: 'Ziina',
    description: 'Connect your venue to Ziina with OAuth 2.0 for hosted payment collection.',
  },
];
